import { TemplatePath } from "@accurx/api/patient-messaging";

export const mapTemplatePathToHeading = (
    path?: Optional<TemplatePath>,
): string | null => {
    return path?.folders?.map((c) => c.name).join(" > ") || null;
};
